import { AWS_URL, IS_PRODUCTION, LANGUAGES_BASE_URL } from '../../env';
import { getSafeLanguage } from './getSafeLanguage';

export const getLanguageFileUrl = (
  language: string,
  context: "app" | "form"
) => {
  const safeLanguage = getSafeLanguage(language);
  const drupalLanguagesBaseUrl = window?.Drupal?.settings?.qn_forms?.languages_base_url;
  const defaultBaseUrl = IS_PRODUCTION
    ? `${AWS_URL}/languages`
    : "/locales";
  const languagesBaseUrl = drupalLanguagesBaseUrl
    || LANGUAGES_BASE_URL
    || defaultBaseUrl;

  return `${languagesBaseUrl}/${context}/${safeLanguage}.json`;
};